import React from "react";
import { activeSocials } from "./socials.config";
import { SOCIAL_GLYPHS, SOCIAL_HOVER_COLOR } from "./SocialGlyphs";

/**
 * Renders the row of brand icon links — Instagram, X, YouTube, etc.
 *
 * Only the platforms with a non-empty URL in `socials.config.js`
 * are shown. To add a new platform: drop its glyph into
 * `SocialGlyphs.js`, register the URL in `socials.config.js`, done.
 *
 * Each link is `target="_blank"` + `rel="noopener noreferrer"` so
 * clicks open in a new tab without leaking the referrer.
 */
export default function SocialLinks({ className = "", iconSize = 18 }) {
  const items = activeSocials();
  if (!items.length) return null;
  return (
    <ul
      data-testid="footer-socials"
      className={`flex items-center gap-4 ${className}`}
    >
      {items.map(({ name, url }) => {
        const Glyph = SOCIAL_GLYPHS[name];
        if (!Glyph) return null;
        const tint = SOCIAL_HOVER_COLOR[name] || "#14b8a6";
        return (
          <li key={name}>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`LEAGUE HUB on ${name[0].toUpperCase() + name.slice(1)}`}
              data-testid={`footer-social-${name}`}
              className="inline-flex items-center justify-center w-9 h-9 rounded-lg border border-white/10 text-white/55 hover:border-white/30 transition-colors"
              style={{ "--hover-tint": tint }}
              onMouseEnter={(e) => { e.currentTarget.style.color = tint; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = ""; }}
            >
              <Glyph width={iconSize} height={iconSize} />
            </a>
          </li>
        );
      })}
    </ul>
  );
}
